<template>
  <div class="duplicates-tab fill-height">
    <!-- Sub page tabs -->
    <sub-page-tabs :selected-index.sync="selectedIndex" :tabs="tabs">
      <!-- Duplicates tab -->
      <page-tab-panel class="pa-6">
        <duplicates-tab-duplicates :review="review" />
      </page-tab-panel>

      <!-- Not duplicates tab -->
      <page-tab-panel class="pa-6">
        <duplicates-tab-not-duplicates :review="review" />
      </page-tab-panel>
    </sub-page-tabs>
  </div>
</template>

<script>
import SubPageTabs from '@/components/Common/SubPageTabs';
import PageTabPanel from '@/components/Common/PageTabPanel';
import DuplicatesTabDuplicates from './DuplicatesTabDuplicates';
import DuplicatesTabNotDuplicates from './DuplicatesTabNotDuplicates';
import { Review } from '@/models';

export default {
  name: 'DuplicatesTab',
  components: {
    SubPageTabs,
    PageTabPanel,
    DuplicatesTabDuplicates,
    DuplicatesTabNotDuplicates,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  data: () => ({ selectedIndex: 0 }),
  computed: {
    tabs() {
      return [
        {
          label: 'Duplicates',
          count: this.review.resolvedDuplicatesCount,
        },
        {
          label: 'Not Duplicates',
          count: this.review.resolvedNotDuplicatesCount,
        },
      ];
    },
  },
};
</script>
